<script>
  import {
    ReadableStream as PolyfillReadableStream,
    TransformStream as PolyfillTransformStream,
  } from "web-streams-polyfill";
  import {
    createReadableStreamWrapper,
    createTransformStreamWrapper,
  } from "@mattiasbuelens/web-streams-adapter";
  const toPolyfillReadable = createReadableStreamWrapper(
    PolyfillReadableStream,
  );

  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import * as openpgp from "openpgp";

  import streamSaver from "streamsaver";
  //import { text } from 'svelte/internal'
  import PartitionedInput from "./PartitionedInput.svelte";
  //import * as bigintConversion from "bigint-conversion";
  //import { crc8, packCrc8, checkPackedCrc8 } from "./crc";
  import ProgressBar from "@okrad/svelte-progressbar";

  let siteData = {};

  let series = { perc: 0, color: "#00793A" };

  let codeValid = false;
  let code = "";
  let date;
  let length = 0;
  let loaded = -1;
  let c = "";

  let devMode = false;
  let crc = 0;
  let acc = "";
  let pacc = 0;
  let pacc10 = 0;

  let years = [],
    months = [],
    days = [];
  let selectY, selectM, selectD;

  let scrolled = false;

  let dialog;
  let hasDownloadCode;
  let taj, accn;

  onMount(async () => {
    const res = await fetch("site.json");
    siteData = await res.json();

    streamSaver.mitm = `https://${siteData.mitm}/mitm.html`;

    const d = new Date();
    const y = d.getFullYear();
    for (let i = y; i > y - 106; --i) years.push(i);
    for (let i = 1; i <= 12; ++i) months.push(i);
    for (let i = 1; i <= 31; ++i) days.push(i);

    years = years;
    months = months;
    days = days;

    const params = new URLSearchParams(window.location.search);
    const cc = params?.get("c");
    if (cc) c = cc;
    else c = "   -   -   -   ";

    dialog.showModal();
  });
  /* 
  $: genCode(acc);
  function genCode(acc) {
    if (!acc) return;
    const bi = parseInt(acc);
    crc = bigintConversion.bigintToHex(crc8(bigintConversion.bigintToBuf(bi)));
    pacc10 = bigintConversion.bufToBigint(
      packCrc8(bigintConversion.bigintToBuf(bi))
    );
    pacc = bigintConversion.bufToHex(
      packCrc8(bigintConversion.bigintToBuf(bi))
    );
  }
 */
  //console.log('load '+streamSaver.mitm)

  var progress = new TransformStream({
    transform(chunk, controller) {
      loaded += chunk.length;
      series.perc = (loaded / length) * 100;
      //console.log(chunk.length, series.perc)
      controller.enqueue(chunk);
    },
  });

  let promise;

  async function download() {
    promise = download_inner();
  }

  async function download_inner() {
    openpgp.config.allowUnauthenticatedStream = true;
    loaded = 0;

    // code = '548648'
    // date = '1950-02-15'

    let url;
    if (hasDownloadCode) url = `/data/${code}.oct`;
    else {
      console.log("accn", accn, BigInt(accn), "taj", taj, BigInt(taj));
      const tmp = BigInt(accn) ^ BigInt(taj);
      url = `/data/${tmp.toString()}.oct`;
    }
    const fileStream = streamSaver.createWriteStream("vizsgalat.zip");

    console.log(url);
    const res = await fetch(url);

    if (!res.ok) {
      // console.log("download failed", res);
      throw new Error(
        "Ezzel az azonosítóval nem található vizsgálat. (Hiba 1)",
      );
    }

    length = +res.headers.get("Content-Length");
    //console.log('download length '+length.toLocaleString('en'))
    const bodyStream = toPolyfillReadable(res.body);

    // more optimized
    if (true || (window.WritableStream && bodyStream.pipeTo)) {
      try {
        const message = await openpgp.readMessage({
          binaryMessage: bodyStream,
          //config: {preferredSymmetricAlgorithm: openpgp.enums.symmetric.cast5}
        });

        const pwd =
          selectY +
          "-" +
          selectM.padStart(2, "0") +
          "-" +
          selectD.padStart(2, "0");
        console.log("pwd", pwd);
        const decrypted = await openpgp.decrypt({
          message,
          passwords: pwd,
          format: "binary",
        });

        return decrypted.data.pipeThrough(progress).pipeTo(fileStream);
      } catch (e) {
        console.dir(e);
        throw new Error(
          "A vizsgálat nem a megadott születési dátummal került feltöltésre. (Hiba 2)",
        );
      }

      //return bodyStream.pipeThrough(progress).pipeTo(fileStream)
    }
    /*
			window.writer = fileStream.getWriter()
			let count = 0
			let t

			const reader = res.body.getReader()
			const pump = () => {
				//console.log('in pump')
				reader.read()
					.then(res => { 
						if (res.done) {
							writer.close()
							console.log(' downloaded '+count)
							console.dir(t)
							return
						}
						else {
							count += res.value.length
							t = res.value
							for (let i=0; i < res.value.length; ++i)
								res.value[i] = res.value[i]+1
							writer.write(res.value).then(pump)
						}
					})
			}

			pump()*/
  }

  function idValid(event) {
    code = event.detail.value;
    codeValid = event.detail.valid;
  }

  function reset(event) {
    loaded = -1;
  }

  function dateChanged() {
    console.log(date + " changed");
  }

  $: setFocus(codeValid, date);
  function setFocus(codeValid, date) {
    const d = document.getElementById("btn");
    if (!d) return;
    if (codeValid && date) {
      d.disabled = false;
      //d.focus()
    } else d.disabled = true;
  }

  function scroll(event) {
    const el = event.srcElement;
    /* console.log(
      el.scrollHeight - el.scrollTop,
      "sH",
      el.scrollHeight,
      "sT",
      el.scrollTop,
      "cH",
      el.clientHeight
    ); */
    if (Math.abs(el.scrollHeight - el.clientHeight - el.scrollTop) < 2)
      scrolled = true;
  }
</script>

<main class="container">
  <dialog
    bind:this={dialog}
    on:close={() => console.log("closed")}
    closedby="none"
  >
    <div class="content">
      <div class="title">
        Rendelkezik letöltési kóddal? (2026. május előtti vizsgálatok)
      </div>

      <div class="buttons">
        <button
          on:click={() => {
            hasDownloadCode = false;
            dialog.close();
          }}
        >
          Nem
        </button>
        <button
          on:click={() => {
            hasDownloadCode = true;
            dialog.close();
          }}
        >
          Igen
        </button>
      </div>
    </div>
  </dialog>

  <div style="grid-area: header;">
    <h1>{siteData.name} vizsgálat letöltő</h1>
  </div>

  <a
    href="hasznalati.html"
    style="grid-area: usersg; color: #AA6C39; font-weight:700; text-decoration-line: underline;"
    >HASZNÁLATI ÚTMUTATÓ</a
  >

  {#if hasDownloadCode}
    <div style="grid-area: label1; justify-self: end; align-self: center;">
      Adja meg a letöltési kódját:
    </div>
    <div
      style="grid-area: control1; justify-self: start; align-self: center; margin-top: 0.4em;"
    >
      <PartitionedInput on:valid={idValid} on:cleared={reset} intval={c} />
    </div>
  {:else}
    <div style="grid-area: label1; justify-self: end; align-self: center;">
      Adja meg a TAJ számát:
    </div>
    <div
      style="grid-area: control1; justify-self: start; align-self: center; margin-top: 0.4em;"
    >
      <input type="text" bind:value={taj} />
    </div>
    <div style="grid-area: label2; justify-self: end; align-self: center;">
      Adja meg a megrendelés számát:
    </div>
    <div
      style="grid-area: control2; justify-self: start; align-self: center; margin-top: 0.4em;"
    >
      <input type="text" bind:value={accn} />
    </div>
  {/if}
  <div style="grid-area: label3; ; justify-self: end; align-self: center;">
    Adja meg a születési dátumát:
  </div>
  <div
    style="grid-area: control3; justify-self: start; align-self: center; margin-top: 0.4em;"
  >
    <!-- <input
      type="date"
      bind:value={date}
      on:change={dateChanged}
      on:click={reset}
    /> -->
    <input
      type="text"
      list="years"
      bind:value={selectY}
      size="4"
      tabindex="0"
      style="display: inline;"
      placeholder="év"
    />
    <datalist id="years">
      {#each years as y}
        <option>{y}</option>
      {/each}
    </datalist>
    &nbsp;
    <input
      type="text"
      list="months"
      bind:value={selectM}
      size="5"
      tabindex="0"
      style="display: inline;"
      placeholder="hónap"
    />
    <datalist id="months">
      {#each months as m}
        <option>{m}</option>
      {/each}
    </datalist>
    &nbsp;
    <input
      type="text"
      list="days"
      bind:value={selectD}
      size="2"
      tabindex="0"
      style="display: inline;"
      placeholder="nap"
    />
    <datalist id="days">
      {#each days as d}
        <option>{d}</option>
      {/each}
    </datalist>
  </div>
  <div style="grid-area: discl; justify-self: strech; align-self: stretch;">
    {#if devMode}
      <label>Accession num: <input type="text" bind:value={acc} /></label>
      <p>crc: {crc}</p>
      <p>packed: {pacc}</p>
      <p>code: {pacc10.toLocaleString("en")}</p>
    {/if}
    <h3 style="margin-top: 0.2em">Jogi nyilatkozat</h3>
    <div class="legal" on:scroll={scroll} tabindex="0">
      <p>
        Az {siteData.url} weboldal (<b>Rendszer</b>) tulajdonosa
        <b>{siteData.name}</b> CT és MR diagnosztikára működési engedéllyel
        rendelkező egészségügyi szolgáltató. {siteData.name} az {siteData.url} weboldalon
        keresztül teszi páciensei részére biztonságos módon elérhetővé az általa
        2021. február 1. után elvégzett CT és MR vizsgálatok képanyagait. A Rendszer
        üzemeltetője az AZP Consultants Kft.
      </p>
      <p>
        A Rendszerből letölthető CT és MR vizsgálati képanyagok a beteg
        személyes és egészségügyi adatait hordozzák. A beteg személyes adatai
        jogi védelemben részesülnek. A képanyag letöltésére és annak
        megismerésére kizárólag a beteg, az általa meghatalmazott személy,
        valamint jogszabályban meghatározott más személyek jogosultak. A
        képanyag jogosulatlan személy általi letöltése és a belépési adatok
        jogosulatlan személy általi bármilyen módon való felhasználása,
        továbbítása jogellenes, az szigorúan tilos.
      </p>
      <p>
        A képanyag a vizsgálat elvégzésétől számított 30 napig korlátlan számban
        és alkalommal letölthető a megadott belépési kóddal. A jelen jogi
        nyilatkozat elfogadásával Ön nyilatkozik, hogy jogosult a képanyag és az
        általa hordozott személyes adatok megismerésére. A jelen jogi
        nyilatkozat elfogadásával Ön elismeri, hogy a {siteData.name} a képanyagot
        a rendelkezésére bocsátotta.
      </p>
      <p>
        Ne adja át a letöltési kódot és a belépési adatait jogosulatlan
        személynek! {siteData.name} nem vállal felelősséget a belépési adatok más
        személy részére történő átadásával, azok elvesztésével, jogosulatlan személy
        általi megismerésével, felhasználásával okozott közvetlen vagy közvetett
        kárért, adatvesztésért, elmaradt haszonért, üzleti vagy jó hírnév elvesztéséért.
        Amennyiben tudomására jut a belépési kód elvesztése, jogosulatlan személy
        általi megszerzése vagy a belépési adataival történő illetéktelen hozzáférés
        vagy annak kísérlete, köteles erről a {siteData.name}-t haladéktalanul
        értesíteni az
        {siteData.mail} e-mail címen. A belépési kódot zároljuk a képanyag jogosulatlan
        személy általi megismerése elkerülése érdekében és új belépési kódot biztosítunk
        Önnek az Ön megfelelő azonosítását követően.
      </p>
      <p>
        {siteData.name} nyilatkozik, hogy a Rendszer megfelel a hatályos adatvédelmi
        és információbiztonsági szabályoknak.
      </p>
      <p>
        Jelen jogi nyilatkozat 2021. február 1. napjától hatályos. {siteData.name}
        fenntartja a jelen Jogi nyilatkozat megváltoztatásának jogát, amelyről minden
        esetben a weboldal ezen részén értesíti felhasználóit.
      </p>
      <p>A jogi nyilatkozatot megértettem és elfogadom.</p>
    </div>
    {#if !scrolled}
      <p transition:fade style="margin-top: 0.5em;">
        Görgessen a jogi nyilatkozat aljáig a továbblépéshez.
      </p>
    {/if}
  </div>
  <div style="grid-area: downl; justify-self: center;">
    {#if loaded < 0}
      <button
        id="btn"
        on:click={download}
        disabled={!(scrolled && selectY && selectM && selectD)}
        tabindex="0"
      >
        <!-- removed && codeValid from disabled -->
        Letöltés
      </button>
      <!-- <button on:click="{download}">Letöltés</button> -->
    {:else}
      {#await promise}
        <ProgressBar style="radial" thickness="10" textSize="200" {series} />
      {:then}
        <p style="color: #00793A"><strong>letöltés befejeződött</strong></p>
      {:catch error}
        <p style="color: red">{error.message}</p>
        <p>
          További részletekért olvassa el a <a
            href="hasznalati.html"
            style="color: #AA6C39; font-weight:600; text-decoration-line: underline;"
            >HASZNÁLATI ÚTMUTATÓT</a
          >
        </p>
      {/await}
    {/if}
  </div>
</main>
<p style="position:fixed; right:1%; bottom:1%; font-size:small">
  dirX-DS/DL v.9.1.7 ({siteData.side})
</p>

<style>
  main {
    text-align: center;
    padding: 1em;
    margin: 0 auto;
    height: 100%;
  }

  h1 {
    color: rgb(0, 121, 58);
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
    font-family: Gotham;
    margin-block-start: 0.3em;
    margin-block-end: 0;
  }

  h3 {
    margin-top: 0;
  }

  .container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto 2em 3em auto 3em 36.5em 3em;
    grid-template-areas:
      "header header header header"
      "usersg usersg usersg usersg"
      "   .   label1 control1 control1"
      "   .   label2 control2 .   "
      "   .   label3 control3 control3"
      "   .   discl  discl    .   "
      "   .   downl  downl    .   ";
    column-gap: 5px;
    row-gap: 5px;
    align-items: stretch;
  }

  .legal {
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0.5em;
    margin-top: 0.2em;
    border: 1px solid gainsboro;
    text-align: justify;
    white-space: normal;
    height: 30em;
    width: 100%;
  }

  input {
    text-align: center;
  }

  @media (min-width: 900px) {
    main {
      min-width: 900px;
      max-width: 1920px;
      max-height: 900px;
    }
  }

  dialog {
    border: 1px solid black;
    border-radius: 8px;
    padding: 1.5rem;
    width: 20%;
    min-width: 300px;
  }

  dialog::backdrop {
    background-color: #333;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .title {
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }

  .buttons {
    display: flex;
    gap: 0.5rem;
  }

  button {
    cursor: pointer;
  }
</style>
